import { render, staticRenderFns } from "./groupManager.vue?vue&type=template&id=6f7a7808&"
import script from "./groupManager.vue?vue&type=script&lang=js&"
export * from "./groupManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports